import withStyles from '@material-ui/core/styles/withStyles'
import IconButton from '@material-ui/core/IconButton'

export default withStyles({
	root: {
		margin: '0 5px'
	}
})(IconButton)
